const arrowDown = `
  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <defs>
          <path d="M24 0v24H0V0h24z" id="nf9pfe73na"/>
      </defs>
      <g fill="none" xlink:href="#nf9pfe73na">
          <path d="M0 0h24v24H0z"/>
          <path d="m12.004 20.8-1.187-1.142.01-.008-4.183-3.992a.789.789 0 0 1-.002-1.14.86.86 0 0 1 1.19-.002l3.333 3.183V4.841a.841.841 0 1 1 1.681 0l.001 12.881 3.32-3.17a.86.86 0 0 1 1.19.001.789.789 0 0 1-.002 1.14L12.004 20.8z" fill="#038AB7" fill-rule="evenodd"/>
      </g>
  </svg>
`

export default arrowDown
